import { first } from 'lodash';
import { usePersistentDeliveryDates } from 'src/dish-first/usePersistentDeliveryDates';
import { FaCircleInfo } from 'src/shared/design-system/FontAwesome';
import { useMultiCartSelector } from './MultiCart/MultiCartSelector';

export const DeliveryDateMismatchWarning = ({ rightAlignIcon = false }) => {
  const [deliveryDates] = usePersistentDeliveryDates();
  const deliveryDate = first(deliveryDates);
  const cart = useMultiCartSelector(false);

  if (deliveryDate === undefined || (deliveryDate !== undefined && deliveryDate === cart.deliveryDate)) {
    return null;
  }

  return (
    <div className='flex gap-2'>
      {!rightAlignIcon && <FaCircleInfo className='mt-0.5 text-base text-raspberry' />}
      <div className='text-sm font-medium'>
        Your selected delivery date doesn't match the date of the items in your cart.
      </div>
      {rightAlignIcon && <FaCircleInfo className='mt-0.5 text-base text-raspberry' />}
    </div>
  );
};
